export default __webpack_public_path__ + "static/media/LEGA9192.4b53e10e.jpg";